import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import StreamSecondaryLogo from "../IME/StreamSecondaryLogo";

const DiscussionInfo = ({
  auth: { isAuthenticated },
  profile,
  live_discussion,
}) => {
  return (
    <Fragment>
      <div className="stream-information-container">
        <div className="stream-info-grid">
          <div className="stream-grid-container">
            <div className="stream-info">
              <img
                // src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${profile.avatar}`}
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/innovator.png`}
                className="streamer-user-avi"
                alt="avatar"
              />
              {live_discussion && live_discussion.live ? (
                <div className="helper-container">
                  <p className="stream-description">
                    {live_discussion && live_discussion.discussiondescription}
                  </p>
                  <div className="stream-keywords">
                    <ul>
                      {live_discussion.keywords.length > 0 &&
                        live_discussion.keywords.map((keyword) => {
                          return (
                            <li
                              className="stream-text-keywords green"
                              key={keyword._id}
                            >
                              {keyword.text}
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                  {live_discussion && live_discussion.live && (
                    <div className="stream-lower-info">
                      <ul class="creator-stream-items">
                        <li class="stream-item green bold">
                          {profile.channelid}
                        </li>
                        <li class="stream-item">
                          {profile.firstname} {profile.lastname}
                        </li>
                        <li class="stream-item">{profile.jobtitle}</li>
                        {/* <li class="stream-item">
                          {profile.location && profile.location.city},{" "}
                          {profile.location && profile.location.state}
                        </li> */}
                      </ul>
                      <ul class="user-count-items">
                        <li class="user-count-item">
                          <i class="fas fa-user-friends fa-lg mr-5 green"></i>
                          <span class="green mr-5 bold">Friends</span>
                          <span class="white bold">552</span>
                        </li>
                        <li class="user-count-item">
                          <i class="fas fa-check fa-lg mr-5 green"></i>
                          <span class="green mr-5 bold">Followers</span>
                          <span class="white bold">5,852</span>
                        </li>
                      </ul>
                      <div class="action-buttons">
                        {isAuthenticated && (
                          <div class="action-items-stream">
                            <div class="action-button green">
                              <i class="far fa-thumbs-up action-icon fa-lg"></i>
                            </div>
                            <p class="action-text">5,768</p>
                          </div>
                        )}
                        {isAuthenticated && (
                          <div class="action-items-stream">
                            <div class="action-button green">
                              <i class="far fa-thumbs-down action-icon fa-lg"></i>
                            </div>
                          </div>
                        )}
                        <div class="action-items-stream">
                          <div class="action-button green">
                            <i class="far fa-user action-icon-alt-two fa-lg"></i>
                          </div>
                          <p class="action-text">5,768</p>
                        </div>
                        {isAuthenticated && (
                          <div class="action-items-stream">
                            <div class="action-button green">
                              <i class="far fa-share-square action-icon fa-lg"></i>
                            </div>
                            <p class="action-text">Share</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="stream-lower-info-offline">
                  <ul class="creator-stream-items">
                    <li class="stream-item green bold">{profile.channelid}</li>
                    <li class="stream-item">
                      {profile.firstname} {profile.lastname}
                    </li>
                    <li class="stream-item">{profile.jobtitle}</li>
                    {/* <li class="stream-item">
                      {profile.location && profile.location.city},{" "}
                      {profile.location && profile.location.state}
                    </li> */}
                  </ul>
                  <ul class="user-count-items">
                    <li class="user-count-item">
                      <i class="fas fa-user-friends fa-lg mr-5 green"></i>
                      <span class="green mr-5 bold">Friends</span>
                      <span class="white bold">552</span>
                    </li>
                    <li class="user-count-item">
                      <i class="fas fa-check fa-lg mr-5 green"></i>
                      <span class="green mr-5 bold">Followers</span>
                      <span class="white bold">5,852</span>
                    </li>
                  </ul>
                  <div class="action-buttons">
                    {isAuthenticated && (
                      <div class="action-items-stream">
                        <div class="action-button green">
                          <i class="far fa-thumbs-up action-icon fa-lg"></i>
                        </div>
                        <p class="action-text">5,768</p>
                      </div>
                    )}
                    {isAuthenticated && (
                      <div class="action-items-stream">
                        <div class="action-button green">
                          <i class="far fa-thumbs-down action-icon fa-lg"></i>
                        </div>
                      </div>
                    )}
                    <div class="action-items-stream">
                      <div class="action-button green">
                        <i class="far fa-user action-icon-alt-two fa-lg"></i>
                      </div>
                      <p class="action-text">5,768</p>
                    </div>
                    {isAuthenticated && (
                      <div class="action-items-stream">
                        <div class="action-button green">
                          <i class="far fa-share-square action-icon fa-lg"></i>
                        </div>
                        <p class="action-text">Share</p>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="stream-grid-container">
            <StreamSecondaryLogo />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

DiscussionInfo.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(DiscussionInfo);
